// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3pqj7","title":"Header_title__1vf7A","left":"Header_left__1Zjag","clinicName":"Header_clinicName__13nyv"};